import { render, staticRenderFns } from "./InfoInt.vue?vue&type=template&id=c84a5452&"
import script from "./InfoInt.vue?vue&type=script&lang=js&"
export * from "./InfoInt.vue?vue&type=script&lang=js&"
import style0 from "./InfoInt.vue?vue&type=style&index=0&id=c84a5452&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports